import { useCart } from "../../context/CartContext";

export default function Header() {
  const { cartCount } = useCart();

  return (
    <div>
      <a
  href="/cart"
  className="relative inline-flex items-center text-[#1e3a8a] transition-colors duration-300 hover:text-[#f97316]"
>
        <svg
          viewBox="0 0 64 64"
          className="h-[33px] w-[40px]"
          fill="none"
          stroke="currentColor"
          strokeWidth="3.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M14 13h7l5.5 27h25l5.5-18H27.5" />
          <path d="M27 40h25" />
          <circle cx="31" cy="51" r="3.5" />
          <circle cx="48" cy="51" r="3.5" />
        </svg>

        <span className="absolute -right-4 -top-3 flex h-[22px] min-w-[34px] items-center justify-center rounded-full bg-[#0a2336] px-2 text-[14px] font-bold leading-none text-white">
  {cartCount}
</span>
      </a>
    </div>
  );
}